import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { UpdatedSchoolParams } from '#server/models';
import { AdminHeader } from './Common/AdminHeader';
import { AdminNavigation } from './Common/AdminNavigation';
import { useIsAdmin } from '@/hooks/use-is-admin';

export const AdminLayout = () => {
  const [updatedSchoolParams, setUpdatedSchoolParams] = useState<UpdatedSchoolParams>({});
  const { data: isAdmin } = useIsAdmin();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAdmin !== undefined && !isAdmin) {
      navigate('/');
    }
  }, [isAdmin]);
  return (
    <div className="flex h-full w-screen flex-col items-start overflow-auto">
      <div className="sticky top-0 z-30 bg-white">
        <AdminHeader updatedSchoolParams={updatedSchoolParams} setUpdatedSchoolParams={setUpdatedSchoolParams} />
        <AdminNavigation />
      </div>
      <Outlet context={{ updatedSchoolParams, setUpdatedSchoolParams }} />
    </div>
  );
};
